import type { AxiosInstance } from 'axios'

let controller = new AbortController()

const ABORT_EXCLUDED_URLS = [
  'support',
  'users/me',
  'my-plan',
  'companies',
  'feature-flags'
]

function isExcludedFromAbort (url: string | undefined): boolean {
  if (!url) {
    return false
  }
  return ABORT_EXCLUDED_URLS.some(excluded => url === excluded || url.startsWith(`${excluded}?`) || url.startsWith(`${excluded}/`))
}

export function getNavigationAbortSignal (): AbortSignal {
  return controller.signal
}

export function abortPendingNavigationRequests (): void {
  controller.abort()
  controller = new AbortController()
}

export function setupNavigationAbortInterceptor (api: AxiosInstance): void {
  api.interceptors.request.use((config) => {
    if (config.method === 'get' && !config.signal && !isExcludedFromAbort(config.url)) {
      config.signal = getNavigationAbortSignal()
    }
    return config
  })
}
